import styles from "./guides.module.css";

const GuideCredsData = ({ label, text }) => {
  const hasLabel = (label || "").trim() !== "";
  return (
    <div
      className={`${styles.container} ${
        hasLabel ? styles["with-label"] : styles["without-label"]
      }`}
    >
      <div className={styles.row}>
        {hasLabel ? (
          <div className={`${styles.wrap} label mb-025`}>{label}</div>
        ) : (
          <></>
        )}
        <div className={`${styles.wrap} bold`}>{text}</div>
      </div>
    </div>
  );
};
export default GuideCredsData;
